import { isFuture, isToday, isValid, parse, parseISO } from "date-fns";
import { isString } from "lodash-es";
import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
var COLOR_LONG_DATE_FORMAT = "PPPP";
var COLOR_DATETIME_FORMAT = `PP, p`;
var COLOR_TIME_WITH_TIMEZONE_FORMAT = `p zzz`;
var COLOR_DATETIME_WITH_TIMEZONE_FORMAT = `PP, p zzz`;
var COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT = `PPPPp zzz`;
//#endregion
//#region src/DateTime/format.ts
var VALID_DATETIME_FORMATS = [
	"PP",
	COLOR_LONG_DATE_FORMAT,
	"p",
	COLOR_DATETIME_FORMAT,
	"zzz",
	COLOR_DATETIME_WITH_TIMEZONE_FORMAT,
	COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT,
	COLOR_TIME_WITH_TIMEZONE_FORMAT
];
var DateTimeFormatError = class extends Error {
	constructor(dateFormat) {
		super(`Unexpected date time format ${dateFormat}`);
	}
};
function getZonedDateTimeFromDateTime(dateTime, timeZone) {
	let dateObj = isString(dateTime) ? parseISO(dateTime) : dateTime;
	if (timeZone) dateObj = utcToZonedTime(dateTime, timeZone);
	return dateObj;
}
/**
* Formats a date according to the given format.
* @param dateTime - The date to format. If string, will parse it to a date object
*/
function formatDateTimeWithFormat(dateTime, dateFormat, options) {
	if (!VALID_DATETIME_FORMATS.includes(dateFormat)) throw new DateTimeFormatError(dateFormat);
	return format(getZonedDateTimeFromDateTime(dateTime, options?.timeZone), dateFormat, options);
}
/**
* Return a formatted date string e.g. "Apr 20, 2020"
*/
function formatDate(date, options) {
	return formatDateTimeWithFormat(date, "PP", options);
}
function formatLongDate(date, options) {
	return formatDateTimeWithFormat(date, COLOR_LONG_DATE_FORMAT, options);
}
function formatDateTime(date, options) {
	return formatDateTimeWithFormat(date, COLOR_DATETIME_FORMAT, options);
}
function formatTime(date, options) {
	return formatDateTimeWithFormat(date, "p", options);
}
function formatTimeZone(date, options) {
	return formatDateTimeWithFormat(date, "zzz", options);
}
function formatTimeWithTimeZone(date, options) {
	return formatDateTimeWithFormat(date, COLOR_TIME_WITH_TIMEZONE_FORMAT, options);
}
function formatDateTimeWithTimeZone(date, options) {
	return formatDateTimeWithFormat(date, COLOR_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
function formatLongDateTimeWithTimeZone(date, options) {
	return formatDateTimeWithFormat(date, COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
/**
* Return a formatted short date string e.g. "Apr 20"
*/
function formatShortDate(date, options) {
	return getZonedDateTimeFromDateTime(date, options?.timeZone).toLocaleDateString(options?.locale, {
		month: "short",
		day: "numeric"
	});
}
/**
* Return a formatted date string without year e.g. "April 20"
*/
function formatDateWithoutYear(date, options) {
	return getZonedDateTimeFromDateTime(date, options?.timeZone).toLocaleDateString(options?.locale, {
		month: "long",
		day: "numeric"
	});
}
/**
* Return a formatted date string with year e.g. "April 20, 2020"
*/
function formatDateWithMonthAndYear(date, options) {
	return getZonedDateTimeFromDateTime(date, options?.timeZone).toLocaleDateString(options?.locale, {
		year: "numeric",
		month: "long",
		day: "numeric"
	});
}
function formatDateRange(dateRange) {
	return `${formatShortDate(dateRange.start)} - ${formatShortDate(dateRange.end)}`;
}
/**
* Return a formatted, localized, short time string or date string:
* - If date is today, return time string e.g. "3:32 PM"
* - If date is before today, return date string with 2 digit year, e.g. "4/17/23"
* - If date is after today, return date string with 4 digit year, e.g. "4/17/2042"
*/
function formatShortDateTime(dateTime, options) {
	const zonedDateTime = getZonedDateTimeFromDateTime(dateTime, options?.timeZone);
	if (isToday(zonedDateTime)) return zonedDateTime.toLocaleTimeString(options?.locale, {
		hour: "numeric",
		minute: "2-digit"
	});
	return dateTime.toLocaleDateString(options?.locale, {
		month: "numeric",
		day: "numeric",
		year: isFuture(zonedDateTime) ? "numeric" : "2-digit"
	});
}
//#endregion
//#region src/DateTime/utils.ts
function getDateFromTimeString(date, timeString, timeZone) {
	let newDate;
	if (/:..:/.test(timeString)) newDate = parse(timeString, "HH:mm:ss", date);
	else newDate = parse(timeString, "HH:mm", date);
	if (!isValid(newDate)) throw new Error(`Failed to parse '${timeString}' into a time.`);
	if (timeZone) return zonedTimeToUtc(newDate, timeZone);
	return newDate;
}
//#endregion
export { formatDateTimeWithTimeZone as a, formatLongDate as c, formatShortDateTime as d, formatTime as f, formatDateTime as i, formatLongDateTimeWithTimeZone as l, formatTimeZone as m, formatDate as n, formatDateWithMonthAndYear as o, formatTimeWithTimeZone as p, formatDateRange as r, formatDateWithoutYear as s, getDateFromTimeString as t, formatShortDate as u };

//# sourceMappingURL=DateTime-CA8CHIxw.js.map